module.exports = __webpack_public_path__ + "static/media/banner.3e007101.jpg";